module.exports = __webpack_public_path__ + "img/S-WEB-Goal-05.faa3ebcd.png";